import React from 'react';
import { render } from 'react-dom';
import NavigationAdmin from './components/navigation-admin';

export default () => {
  const jsonTemplate = document.querySelector('#json');
  const initialItems = jsonTemplate.innerHTML ? JSON.parse(jsonTemplate.innerHTML.replace(/&amp;/g, '&')) : null;
  render(<NavigationAdmin initialItems={initialItems} />, document.querySelector('#nav-admin'));
};
